/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Sdh_RemovalInputs */

const en_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply SDH removal`)
};

const fr_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer la suppression SDH`)
};

const de_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH-Entfernung anwenden`)
};

const it_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicare la rimozione SDH`)
};

const ru_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примените удаление SDH`)
};

const es_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar la eliminación de SDH`)
};

const zh_cn2_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用SDH去除`)
};

const ja_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDH除去を適用する`)
};

const hi_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसडीएच हटाने के लिए आवेदन करें`)
};

const pt_pt2_apply_sdh_removal = /** @type {(inputs: Apply_Sdh_RemovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar remoção de SDH`)
};

/**
* | output |
* | --- |
* | "Apply SDH removal" |
*
* @param {Apply_Sdh_RemovalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_sdh_removal = /** @type {((inputs?: Apply_Sdh_RemovalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Sdh_RemovalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_sdh_removal(inputs)
	if (locale === "de") return de_apply_sdh_removal(inputs)
	if (locale === "it") return it_apply_sdh_removal(inputs)
	if (locale === "ru") return ru_apply_sdh_removal(inputs)
	if (locale === "es") return es_apply_sdh_removal(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_sdh_removal(inputs)
	if (locale === "ja") return ja_apply_sdh_removal(inputs)
	if (locale === "hi") return hi_apply_sdh_removal(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_sdh_removal(inputs)
	return en_apply_sdh_removal(inputs)
});